export default __webpack_public_path__ + "static/media/it.290f2fec.svg";